import { c as _c } from "react/compiler-runtime";
import { Avatar, Box, Heading, HStack, Link, Table, Text } from '@chakra-ui/react';
import { UserAvatar } from '@src/components/sco/Account/UserAvatar';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { ScoUser } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import { uniqBy } from 'lodash';
import { useRouter } from 'next/navigation';
import React from 'react';
type MembersTableRowProps = {
  member: ScoUser;
};
export const MembersTableRow = props => {
  const $ = _c(43);
  const router = useRouter();
  const member = props.member;
  const profileUrl = `/members/${member.slug || member.userId}`;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      bgColor: "container",
      cursor: "pointer"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== profileUrl || $[2] !== router) {
    t1 = () => router.push(profileUrl);
    $[1] = profileUrl;
    $[2] = router;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      size: "md"
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== member) {
    t3 = <UserAvatar avatarProps={t2} disablePopover={true} disablePresence={true} size="xs" user={member} />;
    $[5] = member;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `/founders/${member.slug || member.userId}`;
  let t5;
  if ($[7] !== member.fullName || $[8] !== t4) {
    t5 = <Heading size="md"><Link asChild={true}><NextLink href={t4}>{member.fullName}</NextLink></Link></Heading>;
    $[7] = member.fullName;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== member.title) {
    t6 = member.title && <Text textStyle="labelXs">{member.title}</Text>;
    $[10] = member.title;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <Box>{t5}{t6}</Box>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t3 || $[16] !== t7) {
    t8 = <Table.Cell><HStack gap={4}>{t3}{t7}</HStack></Table.Cell>;
    $[15] = t3;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Avatar.Fallback />;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const t10 = member.company?.logoUrl;
  let t11;
  if ($[19] !== t10) {
    t11 = <Avatar.Root size="xs">{t9}<Avatar.Image src={t10} /></Avatar.Root>;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const t12 = member.company?.name;
  let t13;
  if ($[21] !== t12) {
    t13 = <Text textStyle="labelXs">{t12}</Text>;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t11 || $[24] !== t13) {
    t14 = <Table.Cell><HStack>{t11}{t13}</HStack></Table.Cell>;
    $[23] = t11;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== member.company?.industries) {
    t15 = uniqBy(member.company?.industries, _temp).map(_temp2).join(", ") || "-";
    $[26] = member.company?.industries;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t15) {
    t16 = <Table.Cell><Text textStyle="labelXs">{t15}</Text></Table.Cell>;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  const t17 = member.company?.stage?.title || "-";
  let t18;
  if ($[30] !== t17) {
    t18 = <Table.Cell><Text textStyle="labelXs">{t17}</Text></Table.Cell>;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  const t19 = member.location || member.company?.location || "";
  let t20;
  if ($[32] !== t19) {
    t20 = t19.split(",").slice(0, 2).join(", ");
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t20) {
    t21 = <Table.Cell><Text textStyle="labelXs">{t20}</Text></Table.Cell>;
    $[34] = t20;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] !== t1 || $[37] !== t14 || $[38] !== t16 || $[39] !== t18 || $[40] !== t21 || $[41] !== t8) {
    t22 = <Table.Row _hover={t0} onClick={t1}>{t8}{t14}{t16}{t18}{t21}</Table.Row>;
    $[36] = t1;
    $[37] = t14;
    $[38] = t16;
    $[39] = t18;
    $[40] = t21;
    $[41] = t8;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  return t22;
};
MembersTableRow.fragments = {
  ScoUser: () => gql`
    fragment _ on ScoUser {
      id
      ${UserAvatar.fragments.ScoUser()}
      firstName
      lastName
      fullName
      location
      shortBio
      title
      lastActiveAt
      company {
        id
        companyId
        name
        industries {
          id
          title
        }
        logoUrl
        stage {
          id
          title
        }
        location
      }
    }
  `
};
function _temp(x) {
  return x.title;
}
function _temp2(i) {
  return i.title;
}